'use strict';
import { Pipe, PipeTransform } from '@angular/core';
import { CapTable } from '../../services/captable/captable';

export function investorNameFilter(investorId: string, captable: CapTable) {
    if (investorId && captable.investorFor(investorId)) {
        return captable.investorFor(investorId).name;
    }
}

@Pipe({name: 'investorName'})
export class InvestorNamePipe implements PipeTransform {
    transform(investorId: string, captable: CapTable): string {
        return investorNameFilter(investorId, captable);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/investorNamePipe.ts